import { combineReducers } from 'redux';
import products from './products';
import checkout from './checkout';
import basket from './basket';

export default combineReducers({products, basket, checkout});